import { Playground } from '../../../components/playground/Playground';
import { PlaygroundColors } from '../../../components/playground/PlaygroundColors';
import { PlaygroundClasses } from '../../../components/playground/PlaygroundClasses';
import { Headline } from '../../../components/Headline';
import { colors, getColorNames } from '../../../utils/colors';

export const Panels = () => (
    <div>
        <Headline anchor='panels'>Panels</Headline>
        <Playground
            example={panelsExample}
            classes={panelsClasses}
            availableColors={<PlaygroundColors bgDefault bgPrimary bgSecondary bgInfo bgSuccess bgWarning bgDanger />}
        />
    </div>
);

const eachColor = ['default', ...getColorNames(colors.brand, colors.status)];

const panelsExample = (
    <div className='display-grid grid-cols-1 grid-cols-2-ls grid-cols-4-md gap-20'>
        {eachColor.map(color => (
            <div className={`panel panel-${color} margin-bottom-0`} key={color}>
                <div className='panel-heading'>
                    <div className='display-flex column-gap-10 justify-content-between'>
                        <span>panel-heading</span>
                        <div className='display-flex column-gap-5'>
                            <span>{color !== 'default' && <span className='badge'>1</span>}</span>
                            <span>
                                <span className={`badge badge-${color === 'primary' ? 'secondary' : 'primary'}`}>
                                    1
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div className='panel-body'>panel-body</div>
                <div className='panel-footer'>panel-footer</div>
            </div>
        ))}
    </div>
);

const panelsClasses = (
    <>
        <PlaygroundClasses label='Colors' prefix='panel-' classes={eachColor} />
        <PlaygroundClasses label='Types' prefix='panel-' classes={['heading', 'body', 'footer']} />
    </>
);
